import { create } from "zustand";

export type ContainerRuleSelection =
  | { type: "none" }
  | { type: "deliveryMethod"; id: number }
  | { type: "sellarDistribution" };

export type AvailabilityMap = {
  [productId: number]: { [tierId: number]: boolean };
};

type productVisibilityType = "all" | "active" | "inactive";

type State = {
  search: string;
  setSearch: (search: string) => void;
  productVisibility: productVisibilityType;
  setProductVisibility: (inactiveOnly: productVisibilityType) => void;
  containerRuleSelection: ContainerRuleSelection;
  setContainerRuleSelection: (selection: ContainerRuleSelection) => void;
  availabilityMap: AvailabilityMap;
  setAvailabilityMap: (map: AvailabilityMap) => void;
  toggleAvailability: (productId: number, tierId: number) => void;
  setState: (state: State) => void;
  reset: () => void;
};

export const useAvailabilityListStore = create<State>((set, get) => ({
  search: "",
  setSearch: (search) => set({ search }),
  productVisibility: "all",
  setProductVisibility: (productVisibility) => set({ productVisibility }),
  containerRuleSelection: { type: "none" },
  setContainerRuleSelection: (selection) =>
    set({ containerRuleSelection: selection }),
  availabilityMap: {},
  setAvailabilityMap: (map) => set({ availabilityMap: map }),
  toggleAvailability: (productId, tier) => {
    const map = { ...get().availabilityMap };
    map[productId] = { ...map[productId] };
    map[productId][tier] = !map[productId][tier];
    set({ availabilityMap: map });
  },
  setState: (state) => set(state),
  reset: () =>
    set({
      productVisibility: "all",
      containerRuleSelection: { type: "none" },
    }),
}));
